module.exports = __webpack_public_path__ + "static/media/thumb_loca_503x503.ed86c23b.jpg";